<script setup lang="ts">
import { DialogPortal } from 'reka-ui'
</script>

<template><DialogPortal><slot /></DialogPortal></template>
